// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1RmuH","location":"Header_location__2ztXx"};